import { Box, Container, Paper, Typography, Button } from "@mui/material";
import { CheckCircle as CheckIcon } from "@mui/icons-material";

const SuccessScreen = ({ title, message, buttonText = "Fazer Login" }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: "center",
          }}
        >
          <CheckIcon sx={{ fontSize: 80, color: "success.main", mb: 2 }} />
          <Typography variant="h4" gutterBottom color="success.main">
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            {message}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => window.location.href = "/login"}
          >
            {buttonText}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default SuccessScreen;